import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/circulation-events/`;
const pathById = `${pathBase}:eventId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const circulationEvents = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
};
